import { Modal } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import useI18n from "../hooks/useI18n";

const messages = defineMessages({
    title: {
        id: "Valitse maasi",
        defaultMessage: "Select your country"
    },
    fi: {
        id: "Suomi",
        defaultMessage: "Finland"
    },
    se: {
        id: "Ruotsi",
        defaultMessage: "Sweden"
    },
    no: {
        id: "Norja",
        defaultMessage: "Norway"
    },
    info: {
        id: "Ohjaamme sinut paikalliselle MyRopo-sivustollesi.",
        defaultMessage: "We'll take you to your local MyRopo site."
    },
    close: {
        id: "Sulje",
        defaultMessage: "Close"
    }
});

const CountrySelectionModal = ({ show, onHide, customerType, intl }) => {
    const lng = intl.formatMessage;
    const { systemCountries, getLocale, getCountryFlag } = useI18n();
    const locale = getLocale();

    const countries = systemCountries.filter(c => c.locale !== 'global');

    const buildUrl = (countryLocale) => {
        const base = systemCountries.find(c => c.locale === countryLocale)?.url;
        if (!base) return null;
        return `${base}/user/signin?customerType=${customerType}&lang=${locale}`;
    };

    return (
        <Modal show={show} onHide={onHide} id="country-selection-modal" centered>
            <Modal.Header closeButton>
                <Modal.Title>{lng(messages.title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted">{lng(messages.info)}</p>
                <div className="d-flex flex-column gap-2">
                    {countries.map((country) => {
                        const url = buildUrl(country.locale);
                        if (!url) return null;
                        return (
                            <a
                                key={country.locale}
                                href={url}
                                className="btn country-selection-modal-item"
                            >
                                <span>
                                    <img src={getCountryFlag(country.locale)} alt="" aria-hidden="true" width={20} height={20} />
                                </span>
                                <span className='url'>
                                    {country.url.replace('https://', '')}
                                </span>
                                <span>
                                    ({lng(messages[country.locale])})
                                </span>
                            </a>
                        );
                    })}
                </div>
            </Modal.Body>
        </Modal>
    );
};

CountrySelectionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    customerType: PropTypes.string,
    intl: PropTypes.object.isRequired
};

export default injectIntl(CountrySelectionModal);
